<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="maintainTask">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i>维修任务管理
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <downloadBtn url="extra/pointRepairTask/export/list" :params="seefrom" method="post" :needUserAccount="true"></downloadBtn>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="消防系统">
                <el-select :popper-append-to-body="false" v-model="seefrom.fireControlSystem" placeholder="请选择消防系统" clearable @change="selectFireSystem" @clear="clearFireSystem">
                  <el-option v-for="item in systemList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="设备类型:">
                <el-select :popper-append-to-body="false" v-model="seefrom.deviceType" placeholder="请选择设备类型" style="width:100%" clearable @clear="clearDeviceType">
                  <el-option v-for="(item, index) in deviceList" :key="index" :label="item.deviceType" :value="item.deviceType"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="部门" prop="deptId">
                <el-select :popper-append-to-body="false" v-model="seefrom.deptId" placeholder="请选择部门" clearable>
                  <el-option v-for="item in departmentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="上报开始时间:" label-width="115px">
                <el-date-picker v-model="seefrom.beginTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择开始时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <br>
              <el-form-item label="上报结束时间:" label-width="115px">
                <el-date-picker v-model="seefrom.endTime" value-format="yyyy-MM-dd" type="date" placeholder="请选择结束时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="状态:">
                <el-select :popper-append-to-body="false" v-model="seefrom.status" placeholder="请选择状态" style="width:100%" clearable>
                  <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <el-table :data="tableData" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" :width="width" v-for="({prop,label,align, width}) in config" :key="prop.toString()"></el-table-column>
            <el-table-column label="操作" width="170">
              <template slot-scope="scope">
                <el-link icon="iconfont iconcheck" type="text" size="small" @click="check(scope.$index,  scope.row)">详情
                </el-link>
                <!-- <el-link icon="iconfont iconedit" type="text" size="small" @click="download(scope.row)" v-if="scope.row.status != 0">导出</el-link> -->
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :total="nTotal" :current-page="currentPage">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-dialog class="taskDetailDialog" :visible.sync="detailDialog" :close-on-click-modal="false" width="50%">
        <div class="titleContainer">
          <div class="titleItem" :class="{'active': activeName == 'base' }" @click="changeTab('base')">巡检信息</div>
          <div class="titleItem" :class="{'active': activeName == 'content' }" @click="changeTab('content')">维修信息</div>
          <div class="titleItem" :class="{'active': activeName == 'periodInfo' }" @click="changeTab('periodInfo')">生命周期信息</div>
        </div>
        <keep-alive>
          <template v-if="activeName === 'base'">
            <el-form class="addDevice" ref="base" :model="detail" style="padding: 0; margin-top: 20px" label-width="100px">
              <el-form-item prop="createTime" label="上报时间">
                <p>{{ detail.createTime }}</p>
              </el-form-item>
              <el-form-item prop="fireControlSystem" label="消防系统">
                <p>{{ detail.fireControlSystem }}</p>
              </el-form-item>
              <el-form-item prop="deviceType" label="设备类型">
                <p>{{ detail.deviceType }}</p>
              </el-form-item>
              <el-form-item prop="deviceName" label="设备名称">
                <p>{{ detail.deviceName }}</p>
              </el-form-item>
              <el-form-item prop="deptName" label="所属部门">
                <p>{{ detail.deptName }}</p>
              </el-form-item>
              <el-form-item prop="inspecterName" label="巡检人员">
                <p>{{ detail.inspecterName }}</p>
              </el-form-item>
              <el-form-item prop="inspectResult" label="巡检结果">
                <p>{{ detail.inspectResult }}</p>
              </el-form-item>
              <el-form-item prop="inspectDescription" label="巡检说明">
                <p>{{ detail.inspectDescription }}</p>
              </el-form-item>
              <el-form-item prop="inspectPicture" label="巡检图片">
                <template v-if="detail.inspectPicture">
                  <div style="display: flex;">
                    <div v-for="(bitem, index) in detail.inspectPicture.split(',').filter((item) => item.indexOf('http') != -1)" :key="index">
                      <div>
                        <el-image :src="bitem" :preview-src-list="detail.inspectPicture.split(',').filter((item) => item.indexOf('http') != -1)"
                          style="width: 60px; height: 60px;margin: 0 10px 10px 0;">
                          <div slot="placeholder" class="image-slot">
                            加载中<span class="dot">...</span>
                          </div>
                        </el-image>
                      </div>
                    </div>
                  </div>
                </template>
              </el-form-item>
            </el-form>
          </template>
          <template v-else-if="activeName === 'content'">
            <el-form class="addDevice" ref="base" :model="detail" style="padding: 0; margin-top: 20px" label-width="100px">
              <el-form-item prop="statusName" label="维修状态">
                <p>{{ detail.statusName }}</p>
              </el-form-item>
              <el-form-item prop="endTime" label="截止时间">
                <p>{{ detail.endTime }}</p>
              </el-form-item>
              <el-form-item prop="repairerName" label="维修人员">
                <p>{{ detail.repairerName }}</p>
              </el-form-item>
              <el-form-item prop="repairTime" label="维修时间">
                <p>{{ detail.repairTime }}</p>
              </el-form-item>
              <el-form-item prop="repairResult" label="维修结果">
                <p>{{ detail.repairResult }}</p>
              </el-form-item>
              <el-form-item label="维修图片">
                <template v-if="detail.repairPicture">
                  <div style="display: flex;">
                    <div v-for="(bitem, index) in detail.repairPicture.split(',').filter((item) => item.indexOf('http') != -1)" :key="index">
                      <div>
                        <el-image :src="bitem" :preview-src-list="detail.repairPicture.split(',').filter((item) => item.indexOf('http') != -1)"
                          style="width: 60px; height: 60px;margin: 0 10px 10px 0;">
                          <div slot="placeholder" class="image-slot">
                            加载中<span class="dot">...</span>
                          </div>
                        </el-image>
                      </div>
                    </div>
                  </div>
                </template>
              </el-form-item>
            </el-form>
          </template>
          <template v-else-if="activeName == 'periodInfo'">
            <el-form class="addDevice" ref="base" :model="detail" style="padding: 0; margin-top: 20px" label-width="106px">
              <el-form-item prop="factoryName" label="厂家名称">
                <p>{{ detail.factoryName }}</p>
              </el-form-item>
              <el-form-item prop="productDate" label="出厂日期">
                <p>{{ detail.productDate }}</p>
              </el-form-item>
              <el-form-item prop="validPeriod" label="有效期(年)">
                <p>{{ detail.validPeriod }}</p>
              </el-form-item>
              <el-form-item prop="remainDay" label="到期倒计时(天)">
                <p>{{ detail.remainDay }}</p>
              </el-form-item>
            </el-form>
          </template>
        </keep-alive>
      </el-dialog>
    </el-tabs>
  </div>
</template>

<script>
import { date } from 'utils'
export default {
  name: 'maintainTask',
  data() {
    return {
      form_jsgl: {},
      items: [],
      typeList: [
        {
          label: '巡检故障',
          value: 0
        },
        {
          label: '突发故障',
          value: 1
        }
      ],
      deviceList: [],
      statusList: [
        {
          label: '待维修',
          value: 0
        },
        {
          label: '超时维修',
          value: 1
        },
        {
          label: '已维修',
          value: 2
        }
      ],
      tabName: 'maintainTask',
      seefrom: {},
      tableData: [],
      nTotal: 0,
      currentPage: 1,
      currentSize: 10,
      downloadDialog: false,
      detailDialog: false,
      detail: {},
      departmentList: [],
      systemList: [],
      activeName: 'base'
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'createTime',
          label: '上报时间'
        },
        {
          prop: 'taskName',
          label: '任务名称'
        },
        {
          prop: 'fireControlSystem',
          label: '消防系统'
        },
        {
          prop: 'deviceType',
          label: '设备类型'
        },
        {
          prop: 'endTime',
          label: '截止时间'
        },
        {
          prop: 'statusName',
          label: '维修状态'
        },
        {
          prop: 'deptName',
          label: '维修部门'
        },
        {
          prop: 'repairerName',
          label: '维修人员'
        },
        {
          prop: 'repairTime',
          label: '维修时间'
        }
      ]
    }
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable'),
    downloadBtn: () => import('public/download')
  },
  methods: {
    getSystemList() {
      this.$axiosget('operation/dictionaryType/queryByKey', {
        params: {
          key: 'pointInspectFireCS'
        }
      }).then((res) => {
        if (res.data.status === '10000') {
          this.systemList = res.data.data ? res.data.data.list : []
        }
      })
    },
    selectFireSystem(e) {
      if (e) {
        this.$axiosget('extra/pointInspectContentItem/list', {
          params: {
            fireControlSystem: e
          }
        }).then((res) => {
          this.deviceList = res.data.data
        })
        this.$set(this.seefrom, 'deviceType', undefined)
      }
    },
    clearFireSystem() {
      this.$set(this.seefrom, 'deviceType', undefined)
      this.$set(this.seefrom, 'fireControlSystem', undefined)
      this.deviceList = []
    },
    clearDeviceType() {
      this.$set(this.seefrom, 'deviceType', undefined)
    },
    getDepart() {
      this.$axiosget('operation/deptApi/getDeptList').then((res) => {
        this.departmentList = res.data.data[0].children
      })
    },
    getContentList() {
      this.$axiosget('extra/pointInspectContentItem/list').then((res) => {
        if (res.data.status == 10000) {
          this.deviceList = res.data.data
        }
      })
    },
    //搜索
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    //重置
    reset() {
      this.seefrom = {}
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    // 每页数
    sizeChangeHandle(val) {
      this.currentSize = val
      this.currentPage = 1
      this.getTableData()
    },
    isMaxGtMin() {
      if (!this.seefrom.beginTime || !this.seefrom.endTime) return true
      let s = date(this.seefrom.beginTime)
      let e = date(this.seefrom.endTime)
      let ns = [s.YY, s.MM, s.DD].join('')
      let ne = [e.YY, e.MM, e.DD].join('')
      return ne > ns ? true : false
    },
    //查询表格数据
    getTableData() {
      if (this.seefrom.beginTime && this.seefrom.endTime) {
        if (!this.isMaxGtMin()) {
          this.$notify({
            message: '开始时间需小于结束时间',
            type: 'warning'
          })
          return
        }
      }
      this.$axiosget('extra/pointRepairTask/page', {
        params: {
          pageSize: this.currentSize,
          pageNum: this.currentPage,
          ...this.seefrom,
          startTime: this.seefrom.beginTime
            ? this.seefrom.beginTime + ' 00:00:00'
            : undefined,
          endTime: this.seefrom.endTime
            ? this.seefrom.endTime + ' 23:59:59'
            : undefined
        }
      }).then((res) => {
        if (res.data.data.list.length) {
          this.tableData = res.data.data.list.map((item) => {
            return {
              ...item,
              statusName: this.statusList.find(
                (bitem) => bitem.value === item.status
              ).label
            }
          })
        } else {
          this.tableData = []
        }
        this.nTotal = res.data.data.total
      })
    },
    changeTab(val) {
      this.activeName = val
    },
    check(index, row) {
      let cloneData = _.clone(row)
      this.detail = cloneData
      if (this.detail.inspectPicture) {
        let fileUrl = process.env.fileUrl
        if (
          this.detail.inspectPicture &&
          this.detail.inspectPicture.includes(fileUrl)
        ) {
          if (process.env.SSL_ENABLE || process.env.SSL_ENABLE === 'true') {
            this.detail.inspectPicture = this.detail.inspectPicture.replaceAll(
              fileUrl,
              process.env.SSL_HOST + '/file/'
            )
          }
        }
      }
      if (this.detail.repairPicture) {
        let fileUrl = process.env.fileUrl
        if (
          this.detail.repairPicture &&
          this.detail.repairPicture.includes(fileUrl)
        ) {
          if (process.env.SSL_ENABLE || process.env.SSL_ENABLE === 'true') {
            this.detail.repairPicture = this.detail.repairPicture.replaceAll(
              fileUrl,
              process.env.SSL_HOST + '/file/'
            )
          }
        }
      }
      this.activeName = 'base'
      this.detailDialog = true
    },
    download(row) {
      this.$axiospost(
        `extra/maintenanceRepairTask/export/${
          row.id
        }?companyId=${localStorage.getItem(
          'companyId'
        )}&userId=${localStorage.getItem('userId')}`,
        {
          headers: { 'Content-Type': 'application/x-msdownload' }
        }
      ).then((res) => {
        this.$message.success('下载成功!')
      })
    }
    // openDialog() {
    //   this.downloadDialog = true
    // }
  },
  created() {
    this.getContentList()
    this.getTableData()
    this.getSystemList()
    this.getDepart()
  }
}
</script>

<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
</style>

<style lang="less" scoped>
/deep/ .taskDetailDialog {
  .el-dialog__body {
    padding-top: 10px;
  }

  .titleContainer {
    display: flex;
    background: #2e3657;
    border: 1px solid #214c71;

    & > div {
      width: 100px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      color: #c0c4cc;
      cursor: pointer;

      &.active {
        background: #262d4a;
        color: #409eff;
      }
    }
  }

  .el-form-item {
    margin-bottom: 0;
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/deviceInspect/repairTaskManage/index.vue